import {
  createToolbarComponent,
  RichTextEditorToolbar as Toolbar,
  ListType,
} from '@shopify/online-store-ui';
import type {RichTextEditorInstance as Editor} from '@shopify/online-store-ui';
import {useI18n} from '@shopify/react-i18n';

import {useSharedListProps} from './utilities';
import {unorderedList} from './icons';

export const UnorderedList = createToolbarComponent(
  ListType,
  ({editor, plugin, disabled}) => {
    const [i18n] = useI18n();
    const props = useSharedListProps(editor as Editor, 'unordered');
    const tooltip = disabled ? null : i18n.translate('unorderedList');

    return (
      <Toolbar.Button
        {...props}
        tooltip={tooltip}
        type={plugin.type}
        icon={unorderedList}
        disabled={disabled}
      />
    );
  },
);
